import React            from 'react';

class Value extends React.Component {
    constructor(props) {
        super(props);
        this.state = { };
    }

    render(){
        let p = this.props;
        return(
            <div className={ `simprakit-dropdown-wrapper-value` }>
                <span>{ p.text || p.placeholder }</span>
                <input 
                    type            = "text" 
                    onFocus         = { () => p.openDropdown() }
                    onBlur          = { (e) => p.closeDropdown(e) }
                    ref             = 'CONTAINER'
                    required        = { p.required }
                    value           = { p.selectedValue }
                    onChange        = { () => {} }
                    { ...p.attrs }
                />
            </div>
        )
    }
}

export default Value;